import type { JsonNotation } from "../../royalur/notation/JsonNotation.js";
import { GamePlayerDataNotation } from "./game/GamePlayerDataNotation.js";
import { readJsonString } from "../../util/json.js";
import { PacketIn } from "../game/server/inbound/PacketIn.js";
import { InboundPacketType } from "../game/server/inbound/InboundPacketType.js";
import { buildPacketIn } from "../game/server/inbound/buildPacketIn.js";
import { LobbyNotation } from "../lobby/LobbyNotation.js";
import { RoyalUrJsonNotation } from "../game/royalur/RoyalUrJsonNotation.js";


export class MessageIOContext {
    private readonly lobbyNotation: LobbyNotation;
    private readonly gameNotation: JsonNotation;
    private readonly playerDataNotation: GamePlayerDataNotation;

    constructor(
        lobbyNotation: LobbyNotation,
        gameNotation: JsonNotation,
        playerDataNotation: GamePlayerDataNotation,
    ) {
        this.lobbyNotation = lobbyNotation;
        this.gameNotation = gameNotation;
        this.playerDataNotation = playerDataNotation;
    }

    static createDefault() {
        const playerDataNotation = new GamePlayerDataNotation();
        return new MessageIOContext(
            new LobbyNotation(playerDataNotation),
            new RoyalUrJsonNotation(),
            playerDataNotation,
        );
    }

    getLobbyNotation(): LobbyNotation {
        return this.lobbyNotation;
    }

    getGameNotation(): JsonNotation {
        return this.gameNotation;
    }

    getPlayerDataNotation(): GamePlayerDataNotation {
        return this.playerDataNotation;
    }

    readPacket(json: Record<string, any>) {
        const typeName = readJsonString(json, PacketIn.PACKET_TYPE_KEY);
        const type = InboundPacketType.getByName(typeName);
        const packet = buildPacketIn(type);
        packet.read(this, json);
        return packet;
    }
}
